import { getItemFromCollection } from "directus/src/operations";

export async function fetchClientData({ clientId }) {
  try {
    const response = await getItemFromCollection("clients", clientId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
